import { PortfolioRepo } from '../../../portfolio/portfolio.repo'
import * as _ from 'lodash'
import * as angular from 'angular'
import { TradeSheet } from '../../../trading/models/tradeSheet';
import { TradingRepo } from '../../../trading/trading.repo';

class TradeSheetCompleteness {
    static COMPLETE: string = "COMPLETED";
    static PARTIALLY_COMPLETE: string = "PARTIALLY_COMPLETED";
}

class CompleteTradeSheetDialogController {



    public isLoading: boolean = false;

    public tradeSheet: TradeSheet;
    public completeStates: Array<String> = new Array();
    public stateOfCompleteness: String = "";
    public comment: string = "";

    /** @ngInject */
    constructor(private $mdDialog: angular.material.IDialogService, private portfolioRepo: PortfolioRepo, private notifyjs, private tradingRepo: TradingRepo) {

    }

    $onInit() {
        let that = this;
        that.completeStates.push(TradeSheetCompleteness.COMPLETE);
        that.completeStates.push(TradeSheetCompleteness.PARTIALLY_COMPLETE);
    }


    save() {
        let that = this;
        that.isLoading = true;
        var partiallyComplete = false;
        that.tradeSheet.status = that.stateOfCompleteness;
        that.tradeSheet.reason = that.comment;

        that.tradingRepo.completeTradeSheet(that.tradeSheet.id, that.tradeSheet)
            .then(
            ).catch(err => {
                that.notifyjs(err.data);
            })
            .finally(() => {
                that.isLoading = false;
                that.$mdDialog.hide();
            });

    }

    cancel() {
        this.$mdDialog.cancel();
    }

}

export const completeTradeSheetDialog: angular.IComponentOptions = {
    template: require('./completeTradeSheet.dialog.html'),
    controller: CompleteTradeSheetDialogController,
    bindings: {
        tradeSheet: "<"
    }

}



// WEBPACK FOOTER //
// ./src/app/tradingadmin/tradesheets/completeTradeSheetDialog/completeTradeSheet.dialog.ts